import { render, staticRenderFns } from "./CampaignCreatePeriod.vue?vue&type=template&id=1f98ba86&scoped=true"
import script from "./CampaignCreatePeriod.vue?vue&type=script&lang=ts"
export * from "./CampaignCreatePeriod.vue?vue&type=script&lang=ts"
import style0 from "./CampaignCreatePeriod.vue?vue&type=style&index=0&id=1f98ba86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98ba86",
  null
  
)

export default component.exports